var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0995 8.84945C9.28854 7.73187 7.99295 7 6.49954 7C4.01712 7 1.99951 9.01758 1.99951 11.5C1.99951 13.9824 4.01712 16 6.49954 16C8.17097 16 9.72373 15.1198 10.5842 13.6857L11.8995 11.5L13.2051 9.31426C14.0655 7.88019 15.6183 7 17.2897 7C19.7721 7 21.7897 9.01758 21.7897 11.5C21.7897 13.9824 19.7721 16 17.2897 16C15.8062 16 14.5105 15.2681 13.6897 14.1505",
    stroke: "url(#paint0_linear_2512_31716)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 0L21.8103 2.18973L24 3L21.8103 3.81027L21 6L20.1897 3.81027L18 3L20.1897 2.18973L21 0Z",
    fill: "url(#paint1_linear_2512_31716)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18L5.54018 19.4598L7 20L5.54018 20.5402L5 22L4.45982 20.5402L3 20L4.45982 19.4598L5 18Z",
    fill: "url(#paint2_linear_2512_31716)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.5L11.4051 18.5949L12.5 19L11.4051 19.4051L11 20.5L10.5949 19.4051L9.5 19L10.5949 18.5949L11 17.5Z",
    fill: "url(#paint3_linear_2512_31716)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2512_31716",
    x1: 11.8946,
    y1: 7,
    x2: 11.8946,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2512_31716",
    x1: 21,
    y1: 0,
    x2: 21,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2512_31716",
    x1: 5,
    y1: 18,
    x2: 5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2512_31716",
    x1: 11,
    y1: 17.5,
    x2: 11,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.99014f70db6e04d0f7459e04c242aabf.svg";
export { ForwardRef as ReactComponent };